import { render, staticRenderFns } from "./folder-picker.vue?vue&type=template&id=f19f4d30&"
import script from "./folder-picker.vue?vue&type=script&lang=js&"
export * from "./folder-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports